import { fetchFaturaOptions } from '../proformaPackingListSaida.helpers';
import MultiSelectFiltroOptions from './MultiSelectFiltroOptions';

type Props = {
  name: string;
  label: string;
};

function MultiSelectFatura({ name, label }: Props) {
  return <MultiSelectFiltroOptions name={name} label={label} fetchOptions={fetchFaturaOptions} />;
}

export default MultiSelectFatura;
